/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import { useMutation, useQuery } from '@apollo/react-hooks';
import {
  Jumbotron,
  Container,
  FormGroup,
  Form,
  Label,
  Row,
  Col,
  Button,
  Input,
} from 'reactstrap';
import { CustomerSearch } from '../sav-lovebox/form/customer-search';
import DeleteUser from './delete-user';
import UserData from './user-data';
import UserRelations from './user-relations';
import { GET_USER_DATA } from '../../query/query';
import { GIVE_FREE_LBE, GIVE_LOVECOINS } from '../../mutation/mutation';
import history from '../../router/history';
import GiveDiscountCode from './GiveDiscountCode';

const UserInfo = ({ email, urlRelation }) => {
  const { loading, error, data: { savGetUserData: userData } = {} } = useQuery(
    GET_USER_DATA,
    {
      fetchPolicy: 'network-only',
      variables: { email },
    },
  );

  if (loading) {
    return <p>Loading...</p>;
  }
  if (error) {
    return <p>Error</p>;
  }

  return (
    <Container>
      <UserData userData={userData} email={email} />
      <UserRelations
        relations={userData.relations}
        email={email}
        boxes={userData.boxes}
        urlRelation={urlRelation}
        userId={userData._id}
      />
      <DeleteUser email={email} />
    </Container>
  );
};

const UserInfoPage = ({ match: { params: { email: urlEmail = '', relation: urlRelation = '' } } }) => {
  const [email, setEmail] = useState(urlEmail);
  const [giveFreeLBE] = useMutation(GIVE_FREE_LBE);
  const [giveLovecoins] = useMutation(GIVE_LOVECOINS);

  const updateEmail = (newEmail) => {
    if (newEmail) {
      history.push({
        pathname: `/user/${newEmail}`,
      });
      setEmail(newEmail);
    }
  };

  const handleFreeLBE = async () => {
    try {
      await giveFreeLBE({ variables: { email } });
      // eslint-disable-next-line no-alert
      alert('Success ✅');
    } catch (err) {
      // eslint-disable-next-line no-alert
      alert(`Error :( ${err}`);
    }
  };

  const handleGiveLovecoins = async () => {
    try {
      await giveLovecoins({
        variables: {
          email,
          amount: parseInt(lovecoinsAmount, 10),
        },
      });
      // eslint-disable-next-line no-alert
      alert('Success ✅');
    } catch (err) {
      // eslint-disable-next-line no-alert
      alert(`Error :( ${err}`);
    }
  };

  const [lovecoinsAmount, setLovecoinsAmount] = useState();

  return (
    <Container>
      <Jumbotron className="templates">
        <h3>User Info</h3>
        <hr className="my-2" />
        <CustomerSearch
          email={email}
          onButtonClick={updateEmail}
        />
        {email && (<UserInfo email={email} urlRelation={urlRelation} />)}
      </Jumbotron>
      <Jumbotron>
        <h3>Give discount code</h3>
        <hr className="my-2" />
        <GiveDiscountCode />
      </Jumbotron>
      <Jumbotron className="templates">
        <h3>Give free LBE subscription</h3>
        <hr className="my-2" />
        <Form onSubmit={handleFreeLBE}>
          <FormGroup>
            <Label>Email</Label>
            <Container>
              <Row>
                <Col>
                  <Input
                    type="email"
                    placeholder="Email du client"
                    value={email}
                    onChange={({ target: { value } }) => setEmail(value.toLowerCase())}
                  />
                </Col>
                <Col>
                  <Button
                    type="submit"
                    color="primary"
                  >
                    Valider
                  </Button>
                </Col>
              </Row>
            </Container>
          </FormGroup>
        </Form>
      </Jumbotron>
      <Jumbotron className="templates">
        <h3>Give lovecoins</h3>
        <hr className="my-2" />
        <Form onSubmit={handleGiveLovecoins}>
          <FormGroup>
            <Label>Email</Label>
            <Container>
              <Row>
                <Col>
                  <Input
                    type="email"
                    placeholder="Email du client"
                    value={email}
                    onChange={({ target: { value } }) => setEmail(value.toLowerCase())}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Input
                    type="text"
                    value={lovecoinsAmount}
                    onChange={(evt) => {
                      setLovecoinsAmount(evt.target.value);
                    }}
                    placeholder="Lovecoins amount"
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button
                    type="submit"
                    color="primary"
                  >
                    Valider
                  </Button>
                </Col>
              </Row>
            </Container>
          </FormGroup>
        </Form>
      </Jumbotron>
    </Container>
  );
};

export default UserInfoPage;



// WEBPACK FOOTER //
// ./src/components/user-info/user-info.js